<main @fade>
  <p>
    <ng-select
      [items]="damItemsSelect"
      bindLabel="header"
      bindValue="id"
      [minTermLength]="2"
      [clearable]="false"
      [(ngModel)]="selectedDamItemID"
      typeToSearchText="Пожалуйста, введите 2 или более символов"
      i18n-typeToSearchText="@@TemplateAutocompleteTypeToSearchText"
      placeholder="Выберите освновной элемент"
      i18n-placeholder="@@TemplateAutocompleteLabel"
    />
  </p>

  <p>Объединение элементов объединит все вложения и тэги. Всего вложений: {{ countAllDamVersion }} шт.</p>

  <nb-card-footer>
    <button (click)="unitItems()" nbButton type="button" status="primary">Объединить</button>
  </nb-card-footer>
</main>
